<div class="upp-scale-input" *ngIf="ParentForm" [formGroup]="ParentForm">
    <upp-input class="upp-scale-input__field"
        uppDataid="scale-input-weight"
        [formControlName]="controlName"
        [type]="type"
        [placeholder]="placeholder"
        [title]="title"
        [errornfo]="errornfo"
        [readonly]="readonly"
        [kiosk]="kiosk"
    ></upp-input>
    <div *ngIf="CanScale"
        class="upp-scale-input__status"
        uppDataid="scale-input-status"
        tabindex="0"
        (click)="OnScaleConnect()"
        (keydown.enter)="OnScaleConnect()"
        (keydown.space)="OnScaleConnect()">
        <ion-icon name="speedometer-outline" [color]="ScaleConnected ? 'success' : 'danger'"></ion-icon>
    </div>
</div>
